export interface IGameAnswer {
	correct: boolean
	uid: string
	type: string
	media: IGameAnswerMediaText | IGameAnswerMediaImage
}

export enum AnswerType {
	IMAGE = 'image',
	TEXT = 'text',
}

export interface IGameAnswerMediaTextPayload {
	text: string
}

export interface IGameAnswerMediaText {
	type: AnswerType.TEXT
	payload: IGameAnswerMediaTextPayload
}

export interface IGameAnswerMediaImagePayload {
	source: string
	altText?: string
	isDecorative?: boolean
	assetUid?: string
}

export interface IGameAnswerMediaImage {
	type: AnswerType.IMAGE
	payload: IGameAnswerMediaImagePayload
}

export interface IGameQuestion {
	answers: IGameAnswer[]
	text: string
	asset?: IAsset
	isRandomized: boolean
}

export interface IAsset {
	source: string,
	altText: string,
	isDecorative: boolean,
}

export interface IGameActivity {
	payload: IGameQuestion
	colors: IGameQuestionColors
	finished: boolean
	index: number
	uid: string
	type: string
}

export interface IColor {
	r: number
	g: number
	b: number
	a: number
}

export interface IGameQuestionColors {
	primary: IColor
	secondary: IColor
}
